import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { green } from '../../styles/constants';
import LinkButton from '../LinkButton';

const StyledLink = styled(LinkButton)`
  opacity: ${(props) => props.disabled && 0.5};
  cursor: ${(props) => props.disabled && 'default'};
  
  :hover {
    text-decoration: ${(props) => props.disabled && 'none'};
    text-decoration-color: ${green};
  }
`;

const NavigateToSectionButton = ({
  direction, disabled, handleClick,
}) => {
  let text;
  let iconName;
  switch (direction) {
    case 'up':
      text = 'Vorige';
      iconName = 'chevron-circle-up';
      break;
    case 'down':
      text = 'Volgende';
      iconName = 'chevron-circle-down';
      break;
    default:
      return null;
  }

  return (
    <StyledLink
      onClick={handleClick}
      disabled={disabled}
    >
      <FontAwesomeIcon
        icon={iconName}
        className="mr-2"
        style={{ color: green }}
      />
      {text}
    </StyledLink>
  );
};

NavigateToSectionButton.propTypes = {
  direction: PropTypes.oneOf(['up', 'down']).isRequired,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NavigateToSectionButton.defaultProps = {
  disabled: false,
};

export default NavigateToSectionButton;
